import { render } from "./IFSOrderLineTable.vue?vue&type=template&id=36dedcca&scoped=true"
import script from "./IFSOrderLineTable.vue?vue&type=script&lang=js"
export * from "./IFSOrderLineTable.vue?vue&type=script&lang=js"

import "./IFSOrderLineTable.vue?vue&type=style&index=0&id=36dedcca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dedcca"]])

export default __exports__